export const iconFontAwesomeTransportationJetFighter = (
	<i className="fa-solid fa-jet-fighter"></i>
);
